import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { css } from 'styled-components'

type InnmaxZoomControlProps = {
  onZoomIn?: () => void
  onZoomOut?: () => void
}

const InnmaxZoomControl = (props: InnmaxZoomControlProps) => {
  const { onZoomIn, onZoomOut } = props

  return (
    <div
      css={css`
        pointer-events: auto;
        cursor: pointer;
        box-shadow: 0px 1px 5px 2px #00000047;
        background-color: #fff;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        & div {
          color: #4a4a4a;
          width: 28px;
          height: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:first-child {
            border-bottom: 1px solid #4a4a4a;
          }
        }
      `}>
      <div onClick={onZoomIn}>
        <PlusOutlined />
      </div>
      <div onClick={onZoomOut}>
        <MinusOutlined />
      </div>
    </div>
  )
}

export default InnmaxZoomControl
